import HeaderContainer from "./headerContainer/HeaderContainer";

const Header = () => {
    return (
        <HeaderContainer />
    );
};

export default Header;